import { ServiceFilter } from 'src/app/state/collected-services/collected-services.state-model';

export class LoadCollectedServicesAction {
  static readonly type = '[CollectedServices] Load collected services';
  constructor() {}
}

export class SetSelectedDayAction {
  static readonly type = '[CollectedServices] Set current day';
  constructor(public day: Date) {}
}

export class SetTodayAction {
  static readonly type = '[CollectedServices] Set today';
  constructor() {}
}

export class SetPreviousWeekAction {
  static readonly type = '[CollectedServices] Set previous week';
  constructor() {}
}

export class SetNextWeekAction {
  static readonly type = '[CollectedServices] Set next week';
  constructor() {}
}

export class ResetCollectedServicesAction {
  static readonly type = '[CollectedServices] Reset collected services';
  constructor() {}
}

export class SetServiceFilterAction {
  static readonly type = '[CollectedServices] Set service filter';
  constructor(public filter: ServiceFilter) {}
}

export class ToggleHourlyViewAction {
  static readonly type = '[CollectedServices] Toggle hourly view';
  constructor() {}
}
